﻿import { createElement } from '../utils/dom.js';

const badgeClassMap = {
  hot: 'badge--hot',
  new: 'badge--new',
  'editor-pick': 'badge--editor-pick',
  featured: 'badge--featured',
};

const badgeLabel = badge => badge.toUpperCase();

const formatPlays = value => {
  if (value >= 1000000) return `${(value / 1000000).toFixed(1).replace(/\.0$/, '')}M`;
  if (value >= 1000) return `${(value / 1000).toFixed(1).replace(/\.0$/, '')}K`;
  return value.toString();
};

const renderBadges = (badges = []) => {
  if (!badges.length) return '';
  const items = badges
    .map(badge => `<li class="badge ${badgeClassMap[badge] || ''}">${badgeLabel(badge)}</li>`)
    .join('');
  return `<ul class="game-card__badges">${items}</ul>`;
};

const gameCardTemplate = game => {
  const attributes = [
    `data-categories="${(game.categories || []).join(' ')}"`,
    `data-tags="${(game.tags || []).join(' ')}"`,
    `data-title="${game.title}"`,
    `data-rating="${game.rating || 0}"`,
    `data-plays="${game.plays || 0}"`,
    `data-published="${game.published}"`,
  ].join(' ');

  const primaryCategory = (game.categories || [])[0] || '';
  const formattedCategory = primaryCategory
    .replace(/[-_]/g, ' ')
    .replace(/\b\w/g, char => char.toUpperCase());

  const formattedRating = (game.rating || 0).toFixed(1).replace(/\.0$/, '');

  return `<article class="game-card" data-game ${attributes}>
    <a class="game-card__link" href="/game/${game.slug}/" aria-label="Play ${game.title}">
      <div class="game-card__thumb">
        <img src="${game.thumb}" loading="lazy" alt="${game.title} thumbnail" width="320" height="180" />
        ${renderBadges(game.badges)}
        <span class="game-card__overlay" aria-hidden="true">Play</span>
      </div>
      <div class="game-card__body">
        <h3 class="game-card__title">${game.title}</h3>
        <p class="game-card__meta">${game.provider} - ${formattedCategory}</p>
        <div class="game-card__stats">
          <span class="game-card__rating">&#9733; ${formattedRating}</span>
          <span class="game-card__plays">${formatPlays(game.plays || 0)} plays</span>
        </div>
      </div>
    </a>
  </article>`;
};

export const renderGames = (container, games) => {
  if (!container) return;
  const fragment = document.createDocumentFragment();
  games.forEach(game => {
    fragment.appendChild(createElement(gameCardTemplate(game)));
  });
  container.innerHTML = '';
  container.appendChild(fragment);
};
